<template>
    <div>
        <section class="section-container-color">
            <div class="container section-container-title">
                <!-- Título -->
                <div class="row justify-content-center mb-2">
                    <div class="col-12 col-lg-10 col-xl-8 text-center">
                        <h3 class="text-transparencia font-weight-700 mb-2">
                            ¡ÚNETE A LA RED DE VOLUNTARIADO DE TRANSPARENCIA!
                        </h3>
                        <p class="text-description fs-16 lh-141">
                        <div>La información y contenido de esta página web es elaborada y gestionada por Transparencia.</div>
                        <div class="mt-1 font-weight-600 h5">
                            Inscríbete completando el siguiente formulario:
                        </div>
                        </p>
                    </div>
                </div>

                <!-- Card formulario centrada -->
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8 col-xl-6">
                        <div class="card shadow-3 rounded-box mb-5">
                            <div class="card-body p-4 p-md-5">
                                <form id="frmRegistro" @submit.prevent="saveRegistro" novalidate>
                                    <!-- Nombres y Apellidos -->
                                    <div class="form-group">
                                        <label class="font-weight-600">Nombres y Apellidos </label>
                                        <input type="text" class="form-control" v-model="model.nombresApellidos" required data-parsley-required-message="Ingresa tus nombres y apellidos" data-parsley-max-caracteres-nombre="200" data-parsley-trigger="keyup" />

                                    </div>

                                    <!-- Número de Celular -->
                                    <div class="form-group">
                                        <label class="font-weight-600">Número de Celular </label>
                                        <input type="text" class="form-control" v-model="model.numeroCelular" required data-parsley-required-message="Ingresa tu número de celular" data-parsley-celular-generico data-parsley-trigger="keyup" />

                                    </div>

                                    <!-- Documento -->
                                    <div class="form-row">
                                        <div class="form-group col-12 col-md-6">
                                            <label class="font-weight-600">Tipo de Documento </label>
                                            <select class="form-control" v-model="model.tipoDocumentoParamId" required data-parsley-required-message="Selecciona un tipo de documento">
                                                <option :value="null">Seleccione...</option>
                                                <option v-for="item in tiposDocumento" :key="item.id" :value="item.id">
                                                    {{ item.text }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="form-group col-12 col-md-6">
                                            <label class="font-weight-600">Número de Documento </label>
                                            <input type="text" class="form-control" v-model="model.documentoNumero" required data-parsley-required-message="Ingresa tu número de documento" data-parsley-doc-number data-parsley-trigger="change" />
                                        </div>
                                    </div>

                                    <!-- Fecha de nacimiento y Nacionalidad -->
                                    <div class="form-row">
                                        <div class="form-group col-12 col-md-6">
                                            <label class="font-weight-600">Fecha de Nacimiento </label>
                                            <!--<input type="date" class="form-control" v-model="model.fechaNacimiento" required data-parsley-required-message="Selecciona tu fecha de nacimiento" :data-parsley-min-age="edadMinima" />-->

                                            <input type="date" class="form-control" v-model="model.fechaNacimiento" required :max="fechaMaxNacimiento" data-parsley-required-message="Selecciona tu fecha de nacimiento" data-parsley-trigger="change" />

                                            <p v-if="model.fechaNacimiento" class="mt-1 mb-0 text-primary font-weight-600 text-small">
                                                Edad: <strong>{{ edadCalculada }} años</strong>
                                            </p>
                                        </div>

                                        <div class="form-group col-12 col-md-6">
                                            <label class="font-weight-600">Nacionalidad </label>
                                            <select class="form-control" v-model="model.nacionalidadParamId" required data-parsley-required-message="Selecciona tu nacionalidad">
                                                <option :value="null">Seleccione...</option>
                                                <option v-for="item in nacionalidades" :key="item.id" :value="item.id">
                                                    {{ item.text }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <!-- Correo -->
                                    <div class="form-group">
                                        <label class="font-weight-600">Correo Electrónico </label>
                                        <input type="email" class="form-control" v-model="model.correoElectronico" required data-parsley-required-message="Ingresa tu correo electrónico" data-parsley-email-advanced />
                                    </div>

                                    <!-- Región / Provincia / Distrito -->
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="font-weight-600">Región donde resides </label>
                                            <select class="form-control" v-model="model.regionId" @change="onRegionChange" required data-parsley-required-message="Selecciona la región donde resides">
                                                <option :value="null">Seleccione...</option>
                                                <option :value="-1">Soy extranjero/a</option>
                                                <option v-for="item in regiones" :key="item.id" :value="item.id">
                                                    {{ item.text }}
                                                </option>
                                            </select>
                                        </div>

                                        <!-- Input libre SOLO si es extranjero -->
                                        <div class="form-group" v-if="model.regionId === -1">
                                            <label class="font-weight-600">Región / ciudad donde resides</label>
                                            <input type="text" class="form-control" v-model="model.regionExtranjeroTexto" maxlength="50" required data-parsley-required-message="Indica tu lugar de residencia" data-parsley-maxlength="50" data-parsley-maxlength-message="Máximo 50 caracteres" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-12 col-md-6">
                                            <label class="font-weight-600">Provincia </label>
                                            <select class="form-control" v-model="model.provinciaId" @change="onProvinciaChange" :disabled="model.regionId === -1 || !provincias.length" :required="model.regionId !== -1" data-parsley-required-message="Selecciona la provincia">
                                                <option :value="null">Seleccione...</option>
                                                <option v-for="item in provincias" :key="item.id" :value="item.id">
                                                    {{ item.text }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="form-group col-12 col-md-6">
                                            <label class="font-weight-600">Distrito </label>
                                            <select class="form-control" v-model="model.distritoId" :disabled="model.regionId === -1 || !distritos.length" :required="model.regionId !== -1" data-parsley-required-message="Selecciona el distrito">
                                                <option :value="null">Seleccione...</option>
                                                <option v-for="item in distritos" :key="item.id" :value="item.id">
                                                    {{ item.text }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <!-- Región donde vota -->
                                    <div class="form-group">
                                        <label class="font-weight-600">¿En qué región votas? </label>
                                        <select class="form-control" v-model="model.regionVotoId" required data-parsley-required-message="Selecciona la región donde votas">
                                            <option :value="null">Seleccione...</option>
                                            <option :value="-1">Soy extranjero/a</option>
                                            <option v-for="item in regionesVoto" :key="item.id" :value="item.id">
                                                {{ item.text }}
                                            </option>
                                        </select>
                                    </div>

                                    <!-- Input libre SOLO si es extranjero -->
                                    <div class="form-group" v-if="model.regionVotoId === -1">
                                        <label class="font-weight-600">Región donde votas</label>
                                        <input type="text" class="form-control" v-model="model.regionVotoExtranjeroTexto" maxlength="50" required data-parsley-required-message="Indica el país donde votas" data-parsley-maxlength="50" data-parsley-maxlength-message="Máximo 50 caracteres" />
                                    </div>

                                    <!-- Militancia -->
                                    <div class="form-group">
                                        <label class="font-weight-600">
                                            ¿Eres militante de alguna organización partidaria?
                                        </label>
                                        <small class="d-block text-muted mb-1">
                                            Organización partidaria: Partido político, movimiento político, alianzas.
                                        </small>
                                        <select class="form-control" v-model="model.militanciaCodigo" required data-parsley-required-message="Indica tu situación de militancia">
                                            <option :value="null">Seleccione...</option>
                                            <option v-for="item in militancias" :key="item.id" :value="item.id">
                                                {{ item.text }}
                                            </option>
                                        </select>
                                    </div>

                                    <!-- Voluntario previo -->
                                    <div class="form-group">
                                        <div class="form-check">
                                            <label class="form-check-label">
                                                <input type="checkbox" class="form-check-input" v-model="model.fueVoluntarioTransparencia" />
                                                <span class="font-weight-600">¿Ya fuiste voluntario de Transparencia?</span>
                                            </label>
                                        </div>
                                    </div>

                                    <!-- division  
                                    <div class="divider"></div>-->
                                    <!-- disclaimer -->
                                    <div class="form-group">
                                        <div style="background-color: rgb(243 242 242);padding: 16px;border-radius: 6px;">
                                            <label class="text-justify text-style-italic" style="line-height: 20px;">
                                                <small> Los datos en este formulario son recogidos y tratados directamente por Transparencia. Si deseas contactarnos directamente o actualizar tu información, puedes escribirnos a <b><a href="mailto:contactenos@transparencia.org.pe" style="font-weight: bold; color: #003366;">contactenos@transparencia.org.pe</a></b>. Completar este formulario es el primer paso para ser voluntario de Transparencia, tras la revisión de los datos nos contactaremos contigo por correo electrónico para coordinar capacitaciones y actividades y completar tu incorporación como voluntario.</small>
                                            </label>
                                            <div class="form-check ml-3 mb-2">
                                                <label class="form-check-label">
                                                    <input type="checkbox" class="form-check-input" v-model="model.aceptoPoliticaPrivacidad" />
                                                    <span class="font-weight-600 text-underline">
                                                        <a :href="`${filesUrl}/app-Voluntariado/${encodeURIComponent('Política-de-privacidad-y-datos-personales-ACT.pdf')}`" target="_blank" rel="noopener" class="text-body">
                                                            Acepto la Política de Privacidad
                                                        </a>
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Voluntario previo -->
                                    <!-- <div class="form-group">
                                        
                                    </div> -->
                                    <!-- Botón -->
                                    <div class="text-center mt-4">
                                        <button type="button" @click="saveRegistro" class="btn btn-transparencia btn-round px-4">
                                            <i class="fas fa-paper-plane fa-fw mr-1"></i> Enviar Registro
                                        </button>
                                    </div>
                                </form>
                            </div>

                            <!-- <div class="form-group text-right">
                                <small class="text-muted">
                                    Este formulario está protegido por reCAPTCHA y se aplican las
                                    <a href="https://policies.google.com/privacy" target="_blank">Políticas de Privacidad</a> y
                                    <a href="https://policies.google.com/terms" target="_blank">Términos de servicio</a> de Google.
                                </small>
                            </div> -->
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>
<script>

import $ from "jquery";
import "parsleyjs";
import Swal from "sweetalert2";

export default {
    name: "registro-red-voluntariado",
    metaInfo: {
        title: "Participa en la red de voluntariado de Transparencia",
    },
    data: () => ({
        model: {
            nombresApellidos: "",
            numeroCelular: "",
            documentoNumero: "",
            tipoDocumentoParamId: null,
            fechaNacimiento: null,
            edad: null,
            nacionalidadParamId: null,
            correoElectronico: "",
            regionId: null,
            regionExtranjeroTexto: "",
            provinciaId: null,
            distritoId: null,
            regionVotoId: null,
            regionVotoExtranjeroTexto: "",
            militanciaCodigo: null,
            fueVoluntarioTransparencia: false,
            recaptchaToken: null,
            aceptoPoliticaPrivacidad: false,
        },
        militancias: [
            { id: "S", text: "Sí" },
            { id: "N", text: "No" },
            {
                id: "D",
                text: "Estoy en proceso de desafiliación (tengo una carta que lo respalda)"
            }
        ],
        regiones: [],
        regionesVoto: [],
        tiposDocumento: [],
        nacionalidades: [],
        provincias: [],
        distritos: [],
        recaptchaSiteKey: "6LcKDCAsAAAAANAHRV8B_mnPqCkGyGAq7xlIWdUA",
        recaptchaWidgetId: null,
        edadMinima: 10
    }),
    computed: {
        fechaMaxNacimiento() {
            const hoy = new Date();
            hoy.setFullYear(hoy.getFullYear() - 18);

            // yyyy-mm-dd → requerido por input[type=date]
            return hoy.toISOString().split("T")[0];
        },

        edadCalculada() {
            if (!this.model.fechaNacimiento) return null;

            const hoy = new Date();
            const nacimiento = new Date(this.model.fechaNacimiento);

            let edad = hoy.getFullYear() - nacimiento.getFullYear();
            const m = hoy.getMonth() - nacimiento.getMonth();

            if (m < 0 || (m === 0 && hoy.getDate() < nacimiento.getDate())) {
                edad--;
            }

            return edad;
        }
    },
    watch: {
        "model.regionId"(val) {
            if (val !== -1) {
                this.model.regionExtranjeroTexto = "";
            }

            if (val === -1) {
                this.model.provinciaId = null;
                this.model.distritoId = null;
            }
        },
        "model.regionVotoId"(val) {
            if (val !== -1) {
                this.model.regionVotoExtranjeroTexto = "";
            }
        }
    },
    methods: {
        esMayorDeEdad() {
            if (!this.model.fechaNacimiento) return false;

            const hoy = new Date();
            const nacimiento = new Date(this.model.fechaNacimiento);

            let edad = hoy.getFullYear() - nacimiento.getFullYear();
            const m = hoy.getMonth() - nacimiento.getMonth();

            if (m < 0 || (m === 0 && hoy.getDate() < nacimiento.getDate())) {
                edad--;
            }

            return edad >= 18;
        },
        calcularEdad(fecha) {
            if (!fecha) return null;

            const hoy = new Date();
            const cumple = new Date(fecha);

            let edad = hoy.getFullYear() - cumple.getFullYear();
            const mes = hoy.getMonth() - cumple.getMonth();

            // Si aún no cumple años este año → restar 1
            if (mes < 0 || (mes === 0 && hoy.getDate() < cumple.getDate())) {
                edad--;
            }

            return edad;
        },
        // ---------- INIT ----------
        fetchDataInit() {
            // Regiones residencia
            this.$http
                .get(this.apiRoute("Common", "ListRegion"))
                .then(response => {
                    if (!response.body.error) {
                        this.regiones = response.body.data;
                        this.regionesVoto = response.body.data;
                    }
                });

            // Nacionalidades
            const paramsNac = { Code: "NAC" };
            this.$http
                .get(this.apiRoute("Common", "ListParametrosByCode"), { params: paramsNac })
                .then(response => {
                    if (!response.body.error) {
                        this.nacionalidades = response.body.data;
                    }
                });

            // Tipos de documento
            const paramsTip = { Code: "TIP" };
            this.$http
                .get(this.apiRoute("Common", "ListParametrosByCode"), { params: paramsTip })
                .then(response => {
                    if (!response.body.error) {
                        this.tiposDocumento = response.body.data;
                    }
                });
        },

        // ---------- DEPENDENCIAS REGION -> PROVINCIA -> DISTRITO ----------
        onRegionChange() {
            this.model.provinciaId = null;
            this.model.distritoId = null;
            this.provincias = [];
            this.distritos = [];

            // 🔴 Si es extranjero, limpiar errores Parsley y salir
            if (this.model.regionId === -1) {
                this.$nextTick(() => {
                    $("#frmRegistro").parsley().reset();
                });
                return;
            }

            if (!this.model.regionId) return;

            this.loadProvinciasByRegion(this.model.regionId);
        },

        onProvinciaChange() {
            this.model.distritoId = null;
            this.distritos = [];

            if (!this.model.provinciaId) return;

            this.loadDistritosByProvincia(this.model.provinciaId);
        },

        loadProvinciasByRegion(regionId) {
            const params = { regionId: regionId };
            this.$http
                .get(this.apiRoute("Common", "ListProvincias"), { params })
                .then(response => {
                    if (!response.body.error) {
                        this.provincias = response.body.data;
                    }
                });
        },

        loadDistritosByProvincia(provinciaId) {
            const params = { provinciaId: provinciaId };
            this.$http
                .get(this.apiRoute("Common", "ListDistritos"), { params })
                .then(response => {
                    if (!response.body.error) {
                        this.distritos = response.body.data;
                    }
                });
        },

        sendRegistro() {
            const url = this.apiRoute("red-voluntariado", "registro");
            const payload = { ...this.model };

            // 1) Swal loading antes de llamar al API
            Swal.fire({
                title: "Procesando...",
                text: "Por favor espere unos segundos.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            // 2) Llamada al API
            this.$http.post(url, payload).then(response => {

                // 3) Cerrar loading y mostrar resultado
                Swal.close();

                if (response.body.error) {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: response.body.message,
                        confirmButtonText: "Entendido"
                    });
                } else {
                    Swal.fire({
                        title: "¡Éxito!",
                        text: response.body.message,
                        icon: "success",
                        confirmButtonText: "Ok"
                    }).then(result => {
                        if (result.isConfirmed) {
                            this.$router.push("/");
                        }
                    });
                }
            })
                .catch(error => {
                    Swal.close();
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Ocurrió un problema al enviar los datos. Intente nuevamente.",
                    });
                    console.error("Error:", error);
                });
        },
        saveRegistro() {
            // 1) Validar formulario con Parsley primero

            const $form = $("#frmRegistro");
            if (!$form.parsley().validate()) {
                return;
            }
            // 🔴 VALIDACIÓN DEFINITIVA DE EDAD (cross-browser)
            if (!this.esMayorDeEdad()) {
                Swal.fire({
                    icon: "warning",
                    title: "Edad no permitida",
                    text: "Debes ser mayor de 18 años para participar del voluntariado."
                });
                return;
            }

            if (!this.model.aceptoPoliticaPrivacidad) {
                Swal.fire({
                    icon: "warning",
                    title: "¡Atención!",
                    text: "Debe aceptar las políticas de privacidad para continuar.",
                });
                return;
            }
            // 2) Mostrar confirmación previa
            Swal.fire({
                title: "¿Confirmas que tus datos son correctos?",
                text: "Por favor revisa que toda la información ingresada sea la correcta antes de enviar el registro.",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Sí, enviar",
                cancelButtonText: "Revisar",
                reverseButtons: true
            }).then((result) => {

                if (!result.isConfirmed) {
                    return; // Usuario canceló
                }

                // 3) Ejecutar reCAPTCHA V3
                if (!window.grecaptcha) {
                    Swal.fire({
                        icon: "error",
                        title: "Error con reCAPTCHA",
                        text: "No se pudo inicializar el servicio. Intenta nuevamente.",
                    });
                    return;
                }

                window.grecaptcha.ready(() => {
                    window.grecaptcha
                        .execute(this.recaptchaSiteKey, { action: "registro_voluntariado" })
                        .then((token) => {

                            if (!token) {
                                Swal.fire({
                                    icon: "warning",
                                    title: "Validación requerida",
                                    text: "No se pudo validar el reCAPTCHA. Intenta nuevamente.",
                                });
                                return;
                            }

                            this.model.recaptchaToken = token;

                            this.model.edad = this.calcularEdad(this.model.fechaNacimiento);
                            // 4) Enviar registro con loading
                            this.sendRegistro(); // ← usamos tu método ya mejorado
                        })
                        .catch(() => {
                            Swal.fire({
                                icon: "error",
                                title: "Error con reCAPTCHA",
                                text: "Ocurrió un problema inesperado.",
                            });
                        });
                });

            });
        },

    },
    mounted() {
        this.initParsley();
        this.fetchDataInit();

        // 🟦 Regla Parsley para fechas máximas
        window.Parsley.addValidator('minAge', {
            requirementType: 'number',
            validateString: function (value, minAge) {
                const hoy = new Date();
                const fecha = new Date(value);

                // edad calculada
                let edad = hoy.getFullYear() - fecha.getFullYear();
                const mes = hoy.getMonth() - fecha.getMonth();

                if (mes < 0 || (mes === 0 && hoy.getDate() < fecha.getDate())) {
                    edad--;
                }

                return edad >= minAge;
            },
            messages: {
                es: `Debes tener mínimo ${this.edadMinima} años para registrarte.`
            }
        });

        window.Parsley.addValidator('emailAdvanced', {
            requirementType: 'string',
            validateString: function (value) {
                // Regex PRO: cubre la mayoría de casos reales
                const regex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
                return regex.test(value);
            },
            messages: {
                es: "Ingresa un correo electrónico válido."
            }
        });

        window.Parsley.addValidator('docNumber', {
            requirementType: 'string',
            validateString: function (value) {
                // Solo números, entre 8 y 15 dígitos
                const regex = /^[0-9]{8,15}$/;
                return regex.test(value);
            },
            messages: {
                es: "Ingresa un número de documento válido (solo números, entre 8 y 15 dígitos)."
            }
        });

        // Celular genérico: solo números, entre 7 y 20 dígitos
        window.Parsley.addValidator('celularGenerico', {
            requirementType: 'string',
            validateString: function (value) {
                const regex = /^[0-9]{7,20}$/;
                return regex.test(value);
            },
            messages: {
                es: "Ingresa un número de celular válido (solo números, entre 7 y 20 dígitos)."
            }
        });

        // Nombres y apellidos: máximo 200 caracteres
        window.Parsley.addValidator('maxCaracteresNombre', {
            requirementType: 'number',
            validateString: function (value, max) {
                return value.length <= max;
            },
            messages: {
                es: "El nombre no puede exceder los 200 caracteres."
            }
        });

    }
};
</script>
